export const SCHEDULE = {
    GET_SCHEDULE: "schedule/GET_SCHEDULE",
    GET_CREATE_SCHEDULE: "schedule/GET_CREATE_SCHEDULE",
};
